import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { FC } from 'react';
import globalColors from '../globalColors';

const Calendar: FC<CalendarProps> = (props: CalendarProps) => {
    const { isActive, selectedDate, onSelect } = props;
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const shouldDisableYear = (year: Dayjs) => {
        return dayjs(year).year() < dayjs(today).year();
    };

    const shouldDisableDate = (date: Dayjs) => {
        return dayjs(date) < dayjs(yesterday);
    };

    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar
                    value={selectedDate}
                    onChange={(newDate: any) => onSelect(newDate)}
                    disabled={!isActive}
                    shouldDisableYear={shouldDisableYear}
                    shouldDisableDate={shouldDisableDate}
                    sx={{
                        background: !isActive ? '#F6F6FF' : globalColors.backgrounds.grayedLightPurple,
                        color: globalColors.borders.darkPurple,
                        minWidth: '22rem',
                        borderRadius: '4px',
                        position: 'relative',
                        gap: '0px',
                        '& .MuiPickersCalendarHeader-root': {
                            '& .MuiPickersArrowSwitcher-root': {
                                '& .MuiPickersArrowSwitcher-spacer': {
                                    display: 'none !important'
                                }
                            },
                            '& .MuiPickersCalendarHeader-label': {
                                color: !isActive
                                    ? `${globalColors.texts.disabledGray} !important`
                                    : globalColors.texts.activeGray
                            },
                            '& .MuiSvgIcon-root': {
                                fill: !isActive
                                    ? `${globalColors.texts.disabledGray} !important`
                                    : globalColors.texts.activeGray
                            }
                        },
                        '& .MuiDateCalendar-viewTransitionContainer': {
                            '& .MuiTypography-root': {
                                color: !isActive
                                    ? `${globalColors.texts.disabledGray} !important`
                                    : 'rgba(98, 98, 98, 0.50)',
                                border: '1px solid transparent !important',
                                padding: '1.4rem !important',
                                margin: '0 !important'
                            },
                            '& .Mui-disabled:not(.Mui-selected)': {
                                color: `${globalColors.texts.disabledGray} !important`
                            },
                            '& .MuiPickersDay-root': {
                                color: !isActive
                                    ? `${globalColors.texts.disabledGray} !important`
                                    : globalColors.texts.activeGray,
                                margin: '0 !important',
                                padding: '1.4rem !important',
                                border: !isActive ? '1px solid transparent !important' : '1px solid #F4F5FA !important',
                                borderRadius: 0,
                                '&:hover': {
                                    backgroundColor: globalColors.borders.lightPurple,
                                    borderRadius: '60%'
                                },
                                '&:focus': {
                                    backgroundColor: globalColors.borders.darkPurple,
                                    color: '#fff',
                                    borderRadius: '60%'
                                }
                            },
                            '& .MuiDayCalendar-weekContainer': {
                                margin: '0 !important'
                            },
                            '& .MuiPickersYear-root': {
                                '& .Mui-selected': {
                                    backgroundColor: globalColors.borders.darkPurple
                                }
                            },
                            '& .Mui-selected': {
                                backgroundColor: globalColors.borders.darkPurple,
                                borderRadius: '60%'
                            }
                        }
                    }}
                />
            </LocalizationProvider>
        </div>
    );
};

interface CalendarProps {
    isActive: boolean;
    onSelect: Function;
    selectedDate: Dayjs | null;
}

export default Calendar;
